import { render, staticRenderFns } from "./visaStock.vue?vue&type=template&id=4b1f2468&scoped=true"
import script from "./visaStock.vue?vue&type=script&lang=js"
export * from "./visaStock.vue?vue&type=script&lang=js"
import style0 from "./visaStock.vue?vue&type=style&index=0&id=4b1f2468&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f2468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1f2468')) {
      api.createRecord('4b1f2468', component.options)
    } else {
      api.reload('4b1f2468', component.options)
    }
    module.hot.accept("./visaStock.vue?vue&type=template&id=4b1f2468&scoped=true", function () {
      api.rerender('4b1f2468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/visaStock.vue"
export default component.exports